"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollLock = void 0;
var react_1 = require("react");
// touch devices do not support overflow: hidden on body element
// instead we need to prevent default for touchmove event:
// https://stackoverflow.com/a/49853392
var preventDefault = function (event) {
    event.preventDefault();
};
function useScrollLock(lock) {
    // value is stored to prevent body overflow styles override with initial useScrollLock(false)
    var locked = react_1.useRef(false);
    // after scroll is unlocked body overflow style returns to the previous known value
    var bodyOverflow = react_1.useRef(null);
    var unlockScroll = function () {
        if (locked.current) {
            locked.current = false;
            document.body.style.overflow = bodyOverflow.current || '';
            document.body.removeEventListener('touchmove', preventDefault);
        }
    };
    var lockScroll = function () {
        locked.current = true;
        bodyOverflow.current = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        document.body.addEventListener('touchmove', preventDefault, { passive: false });
    };
    react_1.useEffect(function () {
        if (lock) {
            lockScroll();
        }
        else {
            unlockScroll();
        }
        return unlockScroll;
    }, [lock]);
}
exports.useScrollLock = useScrollLock;
